import type { FaireProductEntity } from "../../entity_types/product";

export const p_9sab8k4ztk: FaireProductEntity = {
  token: "p_9sab8k4ztk",
  type: "product",
  name: "100 Percent thank you greeting card",
  brandToken: "b_4cu4uycf",
  brandName: "Red Cap Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/4d75c60f4173c7a7c4a6ba976e4a21b5d8df59d3d6ef5387ea13b6cbdf6205a4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8139ec8df4500e51f4e7576aace3823703cf85ab7290dc2133c7a1dbcafd183.jpeg",
    "https://cdn.faire.com/fastly/8f1de1b409ffc3d61482fb4eb8209e8ad51b17a91e0173a96899565414b685b4.jpeg",
    "https://cdn.faire.com/fastly/ecd7dd7d6f0b5aeb7dbe9bdf2e6c393655620eb6a784e9052dffb5fab023e0df.jpeg",
  ],
  priceDollars: 2.75,
  description:
    "Blank inside. 100lb heavyweight card stock. Offset printed. 5.5 x 4.25 inches. Illustrated by Dylan Mierzwinski. Printed by Red Cap Cards in Los Angeles, California, USA, on recycled paper.\nAvailable as both single cards and pre-packaged boxed cards.\n• Each single card comes with an envelope and a cellophane sleeve.\n• Boxed sets are 8 cards with envelopes and are to be sold as packaged, not to be re-sold as individual cards.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:50.551Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
